import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MatFormField,
  MatFormFieldModule,
  MatLabel,
} from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CityPickerModule } from '../../shared/components/city-picker/city-picker.module';
import { CountryPickerModule } from '../../shared/components/country-picker/country-picker.module';
import { DogBreedPickerModule } from '../../shared/components/dog-breed-picker/dog-breed-picker.module';
import { ImageCropperModule } from '../../shared/components/image-cropper/image-cropper.module';
import { SharedModule } from '../../shared/shared.module';
import { RegisterForOwnerRoutingModule } from './register-for-owner-routing.module';
import { RegisterForOwnerComponent } from './register-for-owner.component';

@NgModule({
  providers: [provideNativeDateAdapter()],
  declarations: [RegisterForOwnerComponent],
  imports: [
    SharedModule,
    RegisterForOwnerRoutingModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatIconModule,
    MatRadioButton,
    MatRadioGroup,
    ImageCropperModule,
    MatDatepickerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    CountryPickerModule,
    CityPickerModule,
    DogBreedPickerModule,
    MatProgressSpinner,
  ],
})
export class RegisterForOwnerModule {}
